<template>
    <Sheet v-loading="loading.global">
        <el-tabs v-model="active">
            <el-tab-pane label="借用登記(管理者專用)" name="booking" lazy >
                <admin-booking></admin-booking>
            </el-tab-pane>
            <el-tab-pane label="空堂查詢(管理者專用)" name="vacancy" lazy >
                <admin-vacancy-room-query></admin-vacancy-room-query>
            </el-tab-pane>
            <el-tab-pane label="表單紀錄" name="manage" lazy>
                <booking-manage :loading="loading.actions['manage']"></booking-manage>
            </el-tab-pane>
            <el-tab-pane label="教室借用紀錄" name="roomManage" lazy>
                <room-booking-manage :loading="loading.actions['manage']"></room-booking-manage>
            </el-tab-pane>
            <el-tab-pane label="承辦人管理" name="userManage" lazy>
                <users-manage :loading="loading.actions['claim']"></users-manage>
            </el-tab-pane>
            <el-tab-pane label="公告管理" name="news" lazy>
                <news-manage :loading="loading.actions['news']"></news-manage>
            </el-tab-pane>
            <el-tab-pane label="不供借用時段設定" name="unavailables" lazy>
                <unavailable-manage :loading="loading.actions['unavailable']"></unavailable-manage>
            </el-tab-pane>
        </el-tabs>
    </Sheet>
</template>

<script>
    import {mapState} from 'vuex';
    import AdminBooking from './AdminBooking';
    import BookingManage from './BookingManage';
    import RoomBookingManage from './RoomBookingManage';
    import UsersManage from './UsersManage';
    import NewsManage from './NewsManage';
    import AdminVacancyRoomQuery from './AdminVacancyRoomQuery';
    import UnavailableManage from './UnavailableManage';

    export default {
        name: 'manage',
        components:{
            BookingManage,
            RoomBookingManage,
            AdminBooking,
            UsersManage,
            NewsManage,
            AdminVacancyRoomQuery,
            UnavailableManage
        },
        data: () =>({
            active: 'booking'
        }),

        computed:{
            ...mapState(['loading']),
            ...mapState('manage', ['bookingParams'])
        },
        watch:{
            bookingParams(current){
                if(current && current.roomId){
                    this.active = 'booking';
                }
            }
        },

        async created() {

        }
    }
</script>

<style>

</style>